import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["fontSize", "disabled", "customPadding", "checkboxColor"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useState } from "react";
import { Checkbox as MuiCheckbox } from "@mui/material";
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import { RaiseColors } from "componentLibrary/theme/RaiseColors";
import { jsx as _jsx } from "react/jsx-runtime";
var Checkbox = function Checkbox(_ref) {
  var _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 20 : _ref$fontSize,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    customPadding = _ref.customPadding,
    _ref$checkboxColor = _ref.checkboxColor,
    checkboxColor = _ref$checkboxColor === void 0 ? RaiseColors.bahama1200 : _ref$checkboxColor,
    muiCheckboxProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var styles = {
    checkboxContainer: {
      width: fontSize,
      height: fontSize,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "1px solid ".concat(RaiseColors.jllNeutral400),
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    checkedIcon: {
      color: RaiseColors.white,
      fontSize: "".concat(_parseInt(fontSize) - 4, "px") // Slightly smaller to fit inside
    }
  };
  return /*#__PURE__*/_jsx(MuiCheckbox, _objectSpread({
    disableRipple: true,
    "data-testid": "checkbox",
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    icon: /*#__PURE__*/_jsx("span", {
      "data-testid": "unchecked-icon",
      style: _objectSpread(_objectSpread({}, styles.checkboxContainer), {}, {
        backgroundColor: RaiseColors.white
      }),
      children: /*#__PURE__*/_jsx("i", {
        style: _objectSpread(_objectSpread({}, styles.checkedIcon), {}, {
          color: RaiseColors.grayscale900,
          opacity: hovered ? 1 : 0,
          transition: "opacity 0.15s ease-in-out"
        }),
        className: IconConstants.CHECK
      })
    }),
    checkedIcon: /*#__PURE__*/_jsx("span", {
      "data-testid": "checked",
      style: _objectSpread(_objectSpread({}, styles.checkboxContainer), {}, {
        border: disabled ? "1px solid ".concat(RaiseColors.jllNeutral700) : "1px solid ".concat(RaiseColors.bahama1200),
        backgroundColor: disabled ? RaiseColors.jllNeutral700 : checkboxColor
      }),
      children: /*#__PURE__*/_jsx("i", {
        style: _objectSpread({}, styles.checkedIcon),
        className: IconConstants.CHECK
      })
    }),
    style: {
      padding: customPadding
    },
    disabled: disabled
  }, muiCheckboxProps));
};
export default Checkbox;